<template>
  <div>
    <v-card>
      <v-card-title class="primary white--text">
        <span class="title">
          Smart Attendance for - {{ smart_attendance_form.name }}
        </span>
      </v-card-title>

      <v-card-text style="margin-top: 20px;">
        <v-text-field flat color="primary" class="pa-0" label="Radio-Frequency IDentification *"
          v-model="smart_attendance_form.ref_id" outlined dense type="number" @keypress="onlyNumberInput"
          :disabled="!smart_attendance_form.with_rfid" />

        <v-select :items="devices" required class="pa-0" label="Device*" outlined dense :disabled="disableOnUpdate"
          v-model="smart_attendance_form.device" />

        <v-layout row wrap class="ma-0">
          <v-flex sm6 class="pr-2">
            <v-calendar-field :margin="0" id-val="card_expiry_from" clearable label="Card Expiry From"
              v-model="smart_attendance_form.card_expiry_from" />
          </v-flex>
          <v-flex sm6 class="pl-2">
            <v-calendar-field :margin="0" id-val="card_expiry_to" clearable label="Card Expiry To"
              v-model="smart_attendance_form.card_expiry_to" />
          </v-flex>
        </v-layout>

        <br>

        <v-text-field v-if="attendance_for === 'student'" flat color="primary" class="pa-0" label="Enroll Code"
          v-model="smart_attendance_form.enroll_code" outlined dense disabled />

        <v-checkbox style="margin-top: -10px !important;" color="error" v-model="smart_attendance_form.with_rfid">
          <template v-slot:label>
            <div style="color: #333;">
              With RFID
              <p style="line-height: 10px">
                <small style="color: #777; font-size: 12px; font-weight: normal">
                  Also push / associate an RFID for this user
                </small>
              </p>
            </div>
          </template>
        </v-checkbox>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="warning" text @click="emitClose">
          Close
        </v-btn>
        <!-- :disabled="isSaveDisabled" -->
        <v-btn color="success" text @click="saveSmartAttendace()" :loading="disableSmartAttendance">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    attendance_for: {
      required: true,
      type: String,
      // default: 'student'
    },
    name: {
      required: true,
      type: String,
    },
    user_details: {
      type: Object,
      default: () => ({}),
    },
    staff_details: {
      type: Object,
      default: () => ({}),
    },
    disableOnUpdate: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    smart_attendance_form: {
      ref_id: '',
      name: '',
      enroll_code: '',
      enroll_id: '',
      grade_id: '',
      section_id: '',
      gender: '',
      user_id: '',
      device: '',
      card_expiry_from: '',
      card_expiry_to: '',
      with_rfid: true,
    },
    devices: [],
    disableSmartAttendance: false,
  }),
  computed: {
    isSaveDisabled() {
      const form = this.smart_attendance_form;
      if (this.disableOnUpdate) return true;
      if (form.with_rfid) return !form.device || !form.ref_id;
      return !form.device;
    },
  },
  mounted() {
    this.getDevices();
  },
  methods: {
    emitClose() {
      this.$emit('clearSmartAttendanceField');
      this.smart_attendance_form = {
        enroll_code: '',
        enroll_id: '',
        grade_id: '',
        section_id: '',
        user_id: '',
        name: '',
        ref_id: '',
        device: '',
        card_expiry_from: '',
        card_expiry_to: '',
        with_rfid: true,
      }
      // this.smartAttendanceDialogueNew = false
      // this.disableOnUpdate = false
    },
    getDevices() {
      this.$rest.get('/api/attendance-devices').then(({ data }) => {
        this.devices = data.data.map((item) => ({
          text: item.name,
          value: item.device_index,
        }));
        this.setFormDetails();
      });
    },
    setFormDetails() {
      const user = this.user_details || {};
      this.smart_attendance_form.ref_id = user.ref_id || '';
      this.smart_attendance_form.name = user.name || '';

      this.smart_attendance_form.ref_id = user.ref_id
      this.smart_attendance_form.enroll_code = user.enroll_code || ''
      this.smart_attendance_form.enroll_id = user.enroll_id || ''
      this.smart_attendance_form.grade_id = user.grade_id || ''
      this.smart_attendance_form.section_id = user.section_id || ''
      this.smart_attendance_form.user_id = user.user_id || ''
      this.smart_attendance_form.name = user.name || ''
      this.smart_attendance_form.card_expiry_from = user.card_expiry_from || ''
      this.smart_attendance_form.card_expiry_to = user.card_expiry_to || ''
      if (user.device) {
        const deviceValue = this.devices.find(device => device.text === user.device)?.value;
        this.smart_attendance_form.device = deviceValue
      }
    },
    onlyNumberInput(event) {
      const charCode = event.charCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    saveSmartAttendace() {
      const { card_expiry_from: from, card_expiry_to: to } = this.smart_attendance_form;
      // One end alone leaves the other on the gateway's default, which can sit
      // before the date that was picked, so the window has to be given whole.
      if (Boolean(from) !== Boolean(to)) {
        this.$events.fire('notification', {
          message: 'Set both card expiry dates, or leave both empty.',
          status: 'error',
        });
        return;
      }
      if (from && to && to < from) {
        this.$events.fire('notification', {
          message: 'Card expiry to date cannot be earlier than the from date.',
          status: 'error',
        });
        return;
      }

      this.disableSmartAttendance = true
      const matchedDevice = this.devices.find(
        (item) => item.value === this.smart_attendance_form.device
      );
      const device_name = matchedDevice ? matchedDevice.text : null;
      let enroll_code = this.smart_attendance_form.enroll_code.split('-')[1];
      const data = {
        device_id: this.smart_attendance_form.device,
        device_name: device_name,
        with_rfid: this.smart_attendance_form.with_rfid ?? 'false',
        type: this.attendance_for,
        users: [
          {
            enroll_code: enroll_code,
            name: this.smart_attendance_form.name,
            card_no: this.smart_attendance_form.ref_id,
            user_id: this.smart_attendance_form.user_id,
            section_id: this.smart_attendance_form.section_id,
            enroll_id: this.smart_attendance_form.enroll_id,
            grade_id: this.smart_attendance_form.grade_id,
            card_expiry_from: this.smart_attendance_form.card_expiry_from,
            card_expiry_to: this.smart_attendance_form.card_expiry_to

          }

        ]
      };
      this.$rest.post(`/api/smart-device-attendance`, data)
        .then((res) => {
          this.smartAttendanceDialogue = false
          this.$emit('resetSmartAttendanceForm');
          this.$events.fire("notification", {
            message: res.data.response.message,
            status: "success",
          });
        }).catch((err) => {
          console.log(err, 'err')
          this.$events.fire("notification", {
            message: err.response.data.message,
            status: "error",
          });
        }).finally((f) => {
          this.disableSmartAttendance = false

        })
    }
  },
};
</script>